


export default{
    data(){
        return{
            constant:{
                ENUM_CHACHE_KEY: 'sh_enum_chache_key_', //枚举缓存Key前缀
            },
            apis:{//接口列表
                members: '/sh/enum/member/list',//获取枚举成员列表
            },
            msg:'',//要显示的内容
        }
    },
    props:{
        enumCode: {//枚举编码，字符串
            type: String,
            default: null
        },
        value:{
            type: [Array, Number],
            default(){
                return null;
            }
        },
        blankText:{//未知成员或成员空白内容时显示的文本，默认‘’
            type:String,
            default: ''
        }
    },
    watch: {
        enumCode(){
            this.checkChache();
        },
        value(){
            this.checkChache();
        }
    },
    mounted() {
        const me = this;
        me.msg = me.blankText; 
        me.checkChache();
    },
    methods: {
        checkChache(){//检测缓存
            const me = this, enumStr = sessionStorage.getItem(me.constant.ENUM_CHACHE_KEY + me.enumCode); 
            if(!enumStr){
                me.loadEnum();
            }else{
                me.enums = JSON.parse(enumStr);
                me.change();
            }
        },
        change(){//从后台获取枚举信息
            const me = this;
            if(!me.enums || me.enums.length <= 0 || me.value === null || me.value === undefined || me.value.length <= 0){
                console.log(me.enums);
                me.msg = me.blankText;
            }else{
                let names = [];
                for(let i in me.enums){
                    let em = me.enums[i];
                    if(me.value instanceof Array ){
                        (me.value.indexOf(em.value) != -1) && names.push(em.name);
                    }else{
                        me.value == em.value && names.push(em.name);
                    }
                }
                me.msg = names.join(',');
            }
        },
        loadEnum(){//从后台获取枚举信息
            const me = this;
            if(!me.enumCode){
                me.$message.error('请传入枚举编码[enumCode]');
                return;
            }
            me.$post({
                url: me.apis.members,
                hideMask:true,
                params:{
                    enumCode: me.enumCode
                }
            }).then(rsp => {
                if(rsp.success){
                    me.enums = rsp.retList;
                    sessionStorage.setItem(me.constant.ENUM_CHACHE_KEY + me.enumCode, JSON.stringify(me.enums));
                    me.change();
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/show/src/show.js